import { useAuthStore } from '../store/auth.store';
import { authApi } from '../api/auth.api';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '../config/queryClient';

export const useAuth = () => {
  const { user, isAuthenticated, setAuth, logout: storeLogout } = useAuthStore();
  const navigate = useNavigate();

  const login = async (credentials) => {
    // Query keys (e.g. ['referrals', ...]) aren't scoped by user/doctor id, so without this,
    // switching accounts in the same browser tab can serve the previous user's cached data —
    // e.g. one clinic doctor briefly seeing another's referred children.
    queryClient.clear();
    const response = await authApi.login(credentials);
    // Response now contains only user and accessToken (refreshToken is httpOnly cookie)
    const { user: userData, accessToken } = response.data;
    setAuth(userData, accessToken);
    message.success('Login successful');
    navigate(userData?.role === 'doctor' && userData?.isReferralDoctor === true ? '/referrals' : '/dashboard');
  };

  const logout = async () => {
    try {
      await authApi.logout();
    } catch {
      // always clear local state
    }
    storeLogout();
    navigate('/login');
    message.success('Logged out successfully');
  };

  const hasRole = (...roles) => roles.includes(user?.role);

  const isAdmin = () => user?.role === 'admin';
  const isSchoolStaff = () => user?.role === 'school_staff';
  const isDoctor = () => user?.role === 'doctor';

  return { user, isAuthenticated, login, logout, hasRole, isAdmin, isSchoolStaff, isDoctor };
};